import axios from 'axios'
import { handleResponse, handleError } from '../helpers/api'
import store from '../store'

const apiPlanningClient = axios.create({
  baseURL: `${window.config.VUE_APP_API_BASE_URL}/Planning`,
  withCredentials: true
})

export const planningService = {
  getOrderList,
  getRestOrderList,
  getRemainingOrders,
  triggerProduction,
  setProductionTime,
  getProductionTime
}

async function triggerProduction(payload) {
  return await apiPlanningClient
    .post('/orderList/trigger', payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}
async function getOrderList(payload) {
  return await apiPlanningClient
    .post('/orderList', payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function getRestOrderList(payload) {
  return await apiPlanningClient
    .post('/restOrderList', payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function getRemainingOrders() {
  return await apiPlanningClient
    .get('/allOrderList', getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}
async function setProductionTime(payload) {
  return apiPlanningClient
    .post('/productionAutoSend/save', payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function getProductionTime() {
  return await apiPlanningClient
    .get('/productionAutoSend', getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

function getHeader() {
  return {
    headers: { Authorization: 'bearer ' + store.getters.jwtToken }
  }
}
